<template>
  <v-textarea
      v-model="localModel"
      v-bind="localProps"
      :rules="localRules"
      :label="localLabel"
      :disabled="disabled"
      :class="schema['x-class']"
  >
  </v-textarea>
</template>

<script>
export default {
  name: "TcnTextArea",
  components: {},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {default: ''},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
    model: {type: Object, required: true},
  },
  data() {
    return {}
  },
  computed: {
    localModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', {key: this.fullKey, value: val !== "" ? val : null})
      },
    },

    localLabel(){
      return this.schema['label'] || null
    },

    localRules() {
      if (this.required) {
        return [value => !!value || this.$t('required'), ...this.rules]
      } else {
        return this.rules
      }
    },

    localProps() {
      const global = this.options['fieldProps']
      const textField = this.options['textFieldProps'] !== undefined && this.options['textFieldProps'] !== null ? this.options['textFieldProps'] : {}
      const forThis = this.schema['x-props'] !== undefined && this.schema['x-props'] !== null ? this.schema['x-props'] : {}
      let result = global !== undefined && global !== null ? global : {}
      result = {...result, ...textField}
      result = {...result, ...forThis}

      if (this.schema["readOnly"]) {
        result = {...result, ...{outlined: false}}
      }
      return result
    },
  },
  watch: {},
  methods: {},
  mounted() {
  }
}
</script>

<style scoped lang="css">

</style>
